module.exports = __webpack_public_path__ + "img/collection-engagementRingsBestseller@2x.60a2131.webp";